import React from 'react';
import { useRouter } from 'next/router';

interface Props {
  items: Item[];
}

interface Item {
  image?: string;
  model?: string;
  year?: string;
  href?: string;
  additionalHref?: {
    label: string;
    href: string;
  }[]
}

const VerGrid: React.FC<Props> = ({ items }) => {
  const router = useRouter();

  const onClick = async (href) => {
    if (href) {
      window.location.href = `https://cdn.volvotechinfo.com${href}`;
    } else {
      await router.push('/under-construction');
    }
  };

  return (
    <React.Fragment>
      <div className="grid">
        {items.map((item, index) => (
          <div
            className="ver-item"
            key={index}
          >
            {item.image && (
              <img
                src={`https://cdn.volvotechinfo.com${item.image}`}
                alt={item.model}
                onClick={() => onClick(item.href)}
              />
            )}
            {item.model && <span>{item.model}</span>}
            {item.year && <span>{item.year}</span>}
            {item.additionalHref &&
              <div className='additional-href'>
                {
                  item.additionalHref.map((ah, index) =>
                    <>
                      <span key={index} className='link' onClick={() => onClick(ah.href)}>{ah.label}</span>
                      {
                        item.additionalHref && index !== item.additionalHref.length - 1 &&
                        <span>|</span>
                      }
                    </>
                  )
                }
              </div>
            }
          </div>
        ))}
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .grid {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .ver-item {
          flex: 0 0 calc(33.333333% - 1rem);
          box-sizing: border-box;
          overflow: hidden;
        }

        @media screen and (max-width: 850px) {
          .ver-item {
            flex: 0 0 calc(50% - 1rem);
          }
        }

        @media screen and (max-width: 600px) {
          .ver-item {
            flex: 0 0 100%;
          }
        }

        .ver-item img {
          width: 100%;
          object-fit: contain;
          cursor: pointer;
        }

        .ver-item span {
          display: block;
          text-align: center;
        }

        span {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
        }

        .additional-href {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 5px;
        }

        .additional-href span {
          display: inline-block;
        }

        .additional-href .link {
          cursor: pointer;
        }
      `}</style>
    </React.Fragment>
  );
};

export default VerGrid;
